import React, {useState} from "react";
import { ListItem,  ListItemText, List, Divider} from '@mui/material';
import { useParams } from "react-router-dom";
import { useUsTiresDetailsQuery, useNhtsaDetailsQuery, useGetAppDetailsQuery  } from "services/ustires";
import RecallsCard from './recalls-card';
import ComplaintsCard from './complaints-card';
import NhtsaHeader  from "./header";
import InvestigationsCard from "./investsigations-card";
import CommunicationsCard from "./communications-card";


const NhtsaDetails = (props) => {

    var { leftMenu } = props;
    
    const { id } = useParams();

    const [tab, setTab] = useState('recalls');
    const [model, setModel] = useState('');

    const {ustiresDetails, ustiresStatus, ustiresLoading, fetching} = useUsTiresDetailsQuery({id: id}, 
        {
            skip: !id,
            selectFromResult: ({ data, status, isLoading, isFetching }) => ({
                ustiresDetails: data || {},
                ustiresStatus: status,
                ustiresLoading: isLoading,
                fetching: isFetching
            })
        }
    );

    const { appDetails, appRecallsCount, appComplaintsCount, appInvestigationsCount, appCommunicationsCount } = useGetAppDetailsQuery(
        { 
            dot:`${ustiresDetails.tin}${ustiresDetails.rangestart}`
        }, 
        {
            skip: !ustiresDetails.model,
            selectFromResult: ({ data, status, isLoading, isFetching }) => ({
                appDetails: data?.content || [],
                appRecallsCount: data?.recallsCount || 0,
                appComplaintsCount: data?.complaintsCount || 0,
                appInvestigationsCount: data?.investigationsCount || 0,
                appCommunicationsCount: data?.communicationsCount || 0
            })
        }
    );

    console.log(appDetails, appRecallsCount, appComplaintsCount);
    
    const { nhtsaDetails, recallsCount, communicationsCount, investigationsCount, complaintsCount } = useNhtsaDetailsQuery(
        { model: ustiresDetails.model, brand: ustiresDetails.brand, size: ustiresDetails.size, query: leftMenu }, 
        {
            skip: !ustiresDetails.model,
            selectFromResult: ({ data, status, isLoading, isFetching }) => ({
                nhtsaDetails: data?.results || [],
                nhtsaMeta: data?.meta || {},
                nhtsaStatus: isLoading,
                nhtsaFetching: isFetching,
                recallsCount: data?.recallsCount,
                complaintsCount: data?.complaintsCount || 0,
                investigationsCount: data?.investigationsCount || 0,
                communicationsCount: data?.manufacturerCommunicationsCount || 0
            })
        }
    );

    console.log(nhtsaDetails);

    return (

        <React.Fragment>
            {leftMenu==="app" ?
            
                <NhtsaHeader {...{
                    tab: tab,
                    setTab: setTab,
                    recallsCount: appRecallsCount, 
                    communicationsCount: appCommunicationsCount, 
                    investigationsCount: appInvestigationsCount, 
                    complaintsCount: appComplaintsCount
                }}/>
            :
            
                <NhtsaHeader {...{
                    tab: tab,
                    setTab: setTab,
                    recallsCount: recallsCount, 
                    communicationsCount: communicationsCount, 
                    investigationsCount: investigationsCount, 
                    complaintsCount: complaintsCount
                }}/>
            }
            {leftMenu==="app" ?
            <React.Fragment>
                {tab==='recalls' ? 
                    <React.Fragment>
                        <List 
                            sx={{
                                padding: 0,
                                marginBottom: 2,
                                width: '100%',
                                border: '1px solid',
                                borderColor: 'divider',
                                backgroundColor: 'background.paper',
                            }}
                            
                        >
                        {appDetails.recalls?.map((r, i)=>
                            <React.Fragment key={i}>
                                <RecallsCard  {...r} />
                                    {i === appDetails.recalls.length - 1 ? '' : <Divider variant="middle" flexItem  />}
                                </React.Fragment>
                        )}
                        </List>
                    </React.Fragment>
                
                :''}
                {tab==='complaints' ? 
                    <React.Fragment>
                        <List 
                            sx={{
                                padding: 0,
                                marginBottom: 2,
                                width: '100%',
                                border: '1px solid',
                                borderColor: 'divider',
                                backgroundColor: 'background.paper',
                            }}
                            
                        >
                        {appDetails.complaints?.map((r, i)=>
                            <React.Fragment key={i}>
                                <ComplaintsCard  {...r} />
                                    {i === appDetails.complaints.length - 1 ? '' : <Divider variant="middle" flexItem  />}
                                </React.Fragment>
                        )}
                        </List>
                    </React.Fragment>
                
                :''}
            </React.Fragment>
            :
            <React.Fragment>
            { nhtsaDetails.map(n=>
                <React.Fragment key={n.artemisId}>
                    {tab==='recalls' && n.recallsCount > 0 ? 
                        <List 
                            sx={{
                                padding: 0,
                                marginBottom: 2,
                                width: '100%',
                                border: '1px solid',
                                borderColor: 'divider',
                                backgroundColor: 'background.paper',
                            }}
                            
                        >
                            <ListItem
                                sx={{
                                    backgroundColor: "#e7e3e3"
                                }}
                            >
                                <ListItemText primary= {`ArtemisId: ${n.artemisId}`} secondary= {`Tire Details: ${n.brand} ${n.tireline} ${n.size === null ? '' : n.size}`} />
                            </ListItem>
                            <Divider variant="middle" flexItem  />
                            {n.safetyIssues.recalls.map((r, i)=>
                                <React.Fragment key={r.id}>
                                    <RecallsCard  {...r} />
                                    {i === n.safetyIssues.recalls.length - 1 ? '' : <Divider variant="middle" flexItem  />}
                                </React.Fragment>
                            )}
                        </List> 
                    : ''}

                    {tab==='complaints' && n.complaintsCount > 0 ? 
                        <List 
                            sx={{
                                padding: 0,
                                marginBottom: 2,
                                width: '100%',
                                border: '1px solid',
                                borderColor: 'divider',
                                backgroundColor: 'background.paper',
                            }}
                            
                        >
                            <ListItem
                                sx={{
                                    backgroundColor: "#e7e3e3"
                                }}
                            >
                                <ListItemText primary= {`ArtemisId: ${n.artemisId}`} secondary= {`Tire Details: ${n.brand} ${n.tireline} ${n.size === null ? '' : n.size}`} />
                            </ListItem>
                            <Divider variant="middle" flexItem  />
                            {n.safetyIssues.complaints.map((r, i)=>
                                <React.Fragment key={r.id}>
                                    <ComplaintsCard  {...r} />
                                    {i === n.safetyIssues.complaints.length - 1 ? '' : <Divider variant="middle" flexItem  />}
                                </React.Fragment>
                            )}
                        </List> 
                    : ''}

                    {tab==='investigations' && n.investigationsCount > 0 ? 
                        <List 
                            sx={{
                                padding: 0,
                                marginBottom: 2,
                                width: '100%',
                                border: '1px solid',
                                borderColor: 'divider',
                                backgroundColor: 'background.paper',
                            }}
                            
                        >
                            <ListItem
                                sx={{
                                    backgroundColor: "#e7e3e3"
                                }}
                            >
                                <ListItemText primary= {`ArtemisId: ${n.artemisId}`} secondary= {`Tire Details: ${n.brand} ${n.tireline} ${n.size === null ? '' : n.size}`} />
                            </ListItem>
                            <Divider variant="middle" flexItem  />
                            {n.safetyIssues.investigations.map((r, i)=>
                                <React.Fragment key={r.id}>
                                    <InvestigationsCard  {...r} />
                                    {i === n.safetyIssues.investigations.length - 1 ? '' : <Divider variant="middle" flexItem  />}
                                </React.Fragment>
                            )}
                        </List> 
                    : ''}

                    {tab==='communications' && n.communicationsCount > 0 ? 
                        <List 
                            sx={{
                                padding: 0,
                                marginBottom: 2,
                                width: '100%',
                                border: '1px solid',
                                borderColor: 'divider',
                                backgroundColor: 'background.paper',
                            }}
                            
                        >
                            <ListItem
                                sx={{
                                    backgroundColor: "#e7e3e3"
                                }}
                            >
                                <ListItemText primary= {`ArtemisId: ${n.artemisId}`} secondary= {`Tire Details: ${n.brand} ${n.tireline} ${n.size === null ? '' : n.size}`} />
                            </ListItem>
                            <Divider variant="middle" flexItem  />
                            {n.safetyIssues.manufacturerCommunications.map((r, i)=>
                                <React.Fragment key={r.id}>
                                    <CommunicationsCard  {...r} />
                                    {i === n.safetyIssues.manufacturerCommunications.length - 1 ? '' : <Divider variant="middle" flexItem  />}
                                </React.Fragment>
                            )}
                        </List> 
                    : ''}
                </React.Fragment>
            )}
            </React.Fragment>}
        </React.Fragment>
    )
}

export default NhtsaDetails;